import type {InferenceApiResponse} from '@/types/inference';

import {getInferenceMockResponse} from './inferenceMock';

let isInferenceMockEnabled = false;
let mockInference: InferenceApiResponse | undefined;

/** Re-applied on every init, so a re-init without the flags turns the mocks back off. */
const apply = ({
    useMockData,
    mockInference: inference,
}: {
    useMockData?: boolean;
    mockInference?: InferenceApiResponse;
}) => {
    isInferenceMockEnabled = useMockData === true;
    mockInference = inference;
};

const isInferenceEnabled = () => isInferenceMockEnabled;

// The host's own mock (a live tour) wins over the built-in one.
const getInferenceResponse = () => mockInference ?? getInferenceMockResponse();

export default {apply, isInferenceEnabled, getInferenceResponse};
